import axios from "axios";
/* Axios allows us to define a base instance in which we can define a URL
  and any other configuration elements
*/
const baseURL = "";

const defaultConfig = {
  baseURL,
  headers: {
    "Content-Type": "application/json",
    common: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
  },
  //  adapter: "fetch",
  // validateStatus: function (status) {
  //   console.log("STATUS", status);
  //   return status < 500; // Resolve only if the status code is less than 500
  // },
  responseType: "json",
};
export function getAPIClient(customConfig = {}) {
  return axios.create({
    ...defaultConfig,
    ...customConfig,
  });
}
const defaultAPIClient = getAPIClient();
export default defaultAPIClient;
